import { get, post, patch, destroy } from './httpClient'

export const getCountries = (query) => get('/country', query)
export const getFullCountries = (query) => get('/address/country', query)
export const addCountry = (body) => post('/country/create', body)
export const updateCountry = (id, body) => patch('/country/update/' + id, body)
export const deleteCountry = (ids) => destroy('/country/delete', { country_id: ids })
